export const currenciesIds = {
    USD: 1,
    BTC: 2,
    LTC: 3,
    RUB: 4,
    EUR: 5,
};

export const currenciesTypes = {
    CRYPTO: 0,
    FIAT: 1
};

export const currenciesPriority = {
    NORMAL: 0,
    HIGH: 1,
    MIDDLE: 2,
};